import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { BillingStateActions } from '@ninety/platform/state/app-global/billing/billing-state.actions';
import { TerraIconModule } from '@ninety/terra';
import { NinetyCMModule } from '@ninety/ui/core';
import { FilterBarActions } from '@ninety/web/pages/shared/layouts';

/**
 * This is just a simple default tiered page.
 * Mainly to help demonstrate how the 'hasFeatureAccessGuard' route guard  works.
 * This is mainly used as a catch-all for tiered pages that have not been implemented yet.
 * */
@Component({
  selector: 'ninety-default-tiered-page',
  standalone: true,
  imports: [TerraIconModule, NinetyCMModule],
  template: `<ninety-cm-tiered-page>
    <div headline>You don’t have access to this tool on your current plan.</div>
    <div description>Upgrade your plan to start using this tool.</div>
    <button ninety-cm-button (click)="onExplorePlansClick()">
      <terra-icon icon="lightning" variant="fill" />
      Explore Plans
    </button>
  </ninety-cm-tiered-page>`,
  styles: [''],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultTieredPageComponent {
  private readonly store = inject(Store);

  constructor() {
    this.store.dispatch(FilterBarActions.hide());
  }

  onExplorePlansClick(): void {
    this.store.dispatch(BillingStateActions.openPricingPlansModal());
  }
}
